import {Step} from "./wizard/WizardMap";
import {I18n} from "aws-amplify";
import {DisposalType, Material, PaymentType} from "./API";

type Dictionary = {
    [key: string]: {
        steps: {
            [key: string]: {
                title: string;
                description?: string;
            }
        },
        downloadButton: string;
        disposalType: {
            [key in DisposalType]: string
        },
        paymentType: {
            [key in PaymentType]: string;
        },
        topBar: {
            whatIsIt: string;
            howDoesItWork: string;
            faq: string
        },
        common: {
            next: string;
            send: string;
            product: string;
            material: string;
            edit: string;
            delete: string;
            brand: string;
            model: string;
            refNr: string;
            unknown: string;
        },
        material: {
            [key in Material]: string;
        }
    }
};

const dictionary: Dictionary = {
    de: {
        steps: {
            [Step.OBJECT_TYPE]: {
                title: "Was möchten Sie verkaufen?"
            }
        },
        downloadButton: "Jetzt herunterladen",
        paymentType: {
            [PaymentType.CASH]: "Bar",
            [PaymentType.TRANSFER]: "Überweisung",
            [PaymentType.PAYPAL]: "PayPal"
        },
        disposalType: {
            [DisposalType.JEWELLERY]: "Schmuck",
            [DisposalType.WATCH]: "Uhr",
            [DisposalType.COIN_BAR]: "Münzen/Barren",
            [DisposalType.DENTAL_GOLD]: "Zahngold",
            [DisposalType.DIAMOND]: "Diamanten"
        },
        topBar: {
            whatIsIt: "Was ist Ankauf per Post?",
            howDoesItWork: "Wie funktioniert's?",
            faq: "FAQ"
        },
        common: {
            product: "Produkt",
            material: "Material",
            edit: "Bearbeiten",
            delete: "Löschen",
            brand: "Marke",
            model: "Modell",
            refNr: "RefNr.",
            unknown: "unbekannt",
            next: "weiter",
            send: "absenden"
        },
        material: {
            [Material.GOLD]: "Gold",
            [Material.SILVER]: "Silber",
            [Material.PLATIN]: "Platin",
            [Material.PALLADIUM]: "Palladium",
            [Material.FASHION]: "Modeschmuck",
            [Material.UNKNOWN_DIFFERENT]: "Unbekannt"
        }
    },
    en: {
        steps: {
            [Step.OBJECT_TYPE]: {
                title: "What do you want to sell?"
            }
        },
        downloadButton: "Jetzt herunterladen",
        paymentType: {
            [PaymentType.CASH]: "Cash",
            [PaymentType.TRANSFER]: "Transfer",
            [PaymentType.PAYPAL]: "PayPal"
        },
        disposalType: {
            [DisposalType.JEWELLERY]: "Jewellery",
            [DisposalType.WATCH]: "Watch",
            [DisposalType.COIN_BAR]: "Coins / Bar",
            [DisposalType.DENTAL_GOLD]: "Dental Gold",
            [DisposalType.DIAMOND]: "Diamonds"
        },
        topBar: {
            whatIsIt: "What is Ankauf per Post?",
            howDoesItWork: "How does it work?",
            faq: "FAQ"
        },
        common: {
            product: "Product",
            material: "Material",
            edit: "Edit",
            delete: "Delete",
            brand: "Brand",
            model: "Model",
            refNr: "RefNr.",
            unknown: "unknown",
            next: "next",
            send: "send"
        },
        material: {
            [Material.GOLD]: "Gold",
            [Material.SILVER]: "Silver",
            [Material.PLATIN]: "Platin",
            [Material.PALLADIUM]: "Palladium",
            [Material.FASHION]: "Fashion",
            [Material.UNKNOWN_DIFFERENT]: "Unknown"
        }
    }
};

export const initDict = () => {
    I18n.setLanguage("de");
    I18n.putVocabularies(dictionary);
};
